import React, { useState } from 'react';
import { Tabs } from '@mantine/core';
import WorkDetailsPanel from './WorkDetailsPanel';
import AssociatedDocumentsPanel from './AssociatedDocumentsPanel';
import ProcedureHistoryPanel from './ProcedureHistoryPanel';
import AuthorizedWaterDistributionPanel from './AuthorizedWaterDistributionPanel';
import IntakeCoordinatesPanel from './IntakeCoordinatesPanel';
import RestitutionCoordinatesPanel from './RestitutionCoordinatesPanel';

const WaterRightDetailRow = ({ row }) => {
	const [activeTab, setActiveTab] = useState('work-details');
	const waterRightData = row.original;

	return (
		<Tabs value={activeTab} onTabChange={setActiveTab} className='p-4' keepMounted={true}>
			<Tabs.List>
				<Tabs.Tab value="work-details">
					Detalle de Obra
				</Tabs.Tab>
				<Tabs.Tab value="documents">
					Documentos Asociados
				</Tabs.Tab>
				<Tabs.Tab value="procedures">
					Historial de Trámites
				</Tabs.Tab>
				<Tabs.Tab value="water-distribution">
					Distribución de Agua Autorizada
				</Tabs.Tab>
				<Tabs.Tab value="intake-coordinates">
					Coordenadas de Captación
				</Tabs.Tab>
				<Tabs.Tab value="restitution-coordinates">
					Coordenadas de Restitución
				</Tabs.Tab>
			</Tabs.List>

			<Tabs.Panel value="work-details" pt="md">
				<WorkDetailsPanel waterRightData={waterRightData} />
			</Tabs.Panel>

			<Tabs.Panel value="documents" pt="md">
				<AssociatedDocumentsPanel waterRightData={waterRightData} />
			</Tabs.Panel>

			<Tabs.Panel value="procedures" pt="md">
				<ProcedureHistoryPanel waterRightData={waterRightData} />
			</Tabs.Panel>

			<Tabs.Panel value="water-distribution" pt="md">
				<AuthorizedWaterDistributionPanel waterRightData={waterRightData} />
			</Tabs.Panel>

			<Tabs.Panel value="intake-coordinates" pt="md">
				<IntakeCoordinatesPanel waterRightData={waterRightData} />
			</Tabs.Panel>

			<Tabs.Panel value="restitution-coordinates" pt="md">
				<RestitutionCoordinatesPanel waterRightData={waterRightData} />
			</Tabs.Panel>
		</Tabs>
	);
};

export default WaterRightDetailRow;
